var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.875V3.125H16.875C17.2202 3.125 17.5 3.40482 17.5 3.75C17.5 4.09518 17.2202 4.375 16.875 4.375H16.202L15.136 17.6994C15.0321 18.9986 13.9474 20 12.644 20H4.85599C3.55259 20 2.46789 18.9986 2.36395 17.6994L1.298 4.375H0.625C0.279822 4.375 0 4.09518 0 3.75C0 3.40482 0.279822 3.125 0.625 3.125H5V1.875C5 0.839466 5.83947 0 6.875 0H10.625C11.6605 0 12.5 0.839466 12.5 1.875ZM6.25 1.875V3.125H11.25V1.875C11.25 1.52982 10.9702 1.25 10.625 1.25H6.875C6.52982 1.25 6.25 1.52982 6.25 1.875ZM4.37499 6.28563L4.99999 16.9106C5.02025 17.2552 5.31603 17.5181 5.66061 17.4978C6.00519 17.4776 6.2681 17.1818 6.24783 16.8372L5.62283 6.21222C5.60256 5.86764 5.30679 5.60473 4.96221 5.625C4.61762 5.64527 4.35471 5.94104 4.37499 6.28563ZM12.5378 5.62608C12.1932 5.60581 11.8974 5.86872 11.8772 6.2133L11.2522 16.8383C11.2319 17.1829 11.4948 17.4787 11.8394 17.4989C12.184 17.5192 12.4797 17.2563 12.5 16.9117L13.125 6.2867C13.1453 5.94212 12.8824 5.64635 12.5378 5.62608ZM8.75 5.625C8.40483 5.625 8.125 5.90482 8.125 6.25V16.875C8.125 17.2202 8.40483 17.5 8.75 17.5C9.09518 17.5 9.375 17.2202 9.375 16.875V6.25C9.375 5.90482 9.09518 5.625 8.75 5.625Z",
    fill: "#CC334C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8e503df49657c0b41a60cc76d3a1437f.svg";
export { ForwardRef as ReactComponent };